"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _button = _interopRequireDefault(require("../button/button.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function RecoverPasswordForm(props) {
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    props.form.validateFields(function (err, values) {
      if (!err) props.recoverPass(values);
    });
  };
  var getFieldDecorator = props.form.getFieldDecorator;
  return /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    onSubmit: handleSubmit,
    className: "login-form"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "Reset password"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "auth-switcher"
  }, "Or", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    onClick: function onClick(e) {
      props.formSwitcher(e, "SignIn");
    }
  }, "sign in to your account")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, "Enter your email address to reset your password. You may need to check your spam folder or unblock", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:no-reply@turing.com",
    style: {
      whiteSpace: "nowrap"
    }
  }, "no-reply@turing.com"), "."), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-label"
  }, "Email"), getFieldDecorator("email", {
    rules: [{
      required: true,
      message: "Enter a valid email address."
    }]
  })( /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    placeholder: "Enter email"
  }))), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    primary: true,
    wide: true,
    label: "Send email confirmation",
    htmlType: "submit",
    className: "login-form-button"
  })));
}
var _default = exports["default"] = RecoverPasswordForm;